/*-
 * ========================LICENSE_START=================================
 * TeamApps
 * ---
 * Copyright (C) 2014 - 2023 TeamApps.org
 * ---
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *      http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================LICENSE_END==================================
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;

import {UiCommand} from "./UiCommand";
import {UiEvent} from "./UiEvent";
import {UiQuery} from "./UiQuery";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";


export interface UiFileItemConfig {
	_type?: string;
	uuid?: string;
	icon?: string;
	thumbnail?: string;
	fileName?: string;
	description?: string;
	size?: number;
	linkUrl?: string
}

export function createUiFileItemConfig(nonRequiredProperties?: {uuid?: string, icon?: string, thumbnail?: string, fileName?: string, description?: string, size?: number, linkUrl?: string}): UiFileItemConfig {
	return {
		_type: "UiFileItem",
		...(nonRequiredProperties||{})
	};
}


